<div class="flex--row flex--nowrap">
  <div class="spacing--margin-right">
    <div class="text--label">
      {{ 'organicMatterBalance' | translate }}
    </div>
    <div class="flex--row flex--nowrap flex--align-center">
      @if (organicMatterBalance < 0) {
        <mat-icon class="text-color--warn">warning</mat-icon>
      }
      @if (organicMatterBalance >= 0) {
        <mat-icon class="text-color--primary">check</mat-icon>
      }
      <span class="flex__child--auto">&nbsp;{{ organicMatterBalance | agrNumber: '1.0-0' }}</span>
    </div>
  </div>
</div>
